import {
  CLEAR_PRODUCTS,
  SET_PRODUCTS,
  SORT_PRODUCTS
} from "../actions/products";
import sortProducts from "../../helpers/sortProducts";

export default (state = [], action) => {
  switch (action.type) {
    case SET_PRODUCTS:
      return action.products;
    case SORT_PRODUCTS:
      return sortProducts(state, action.sortBy);
    case CLEAR_PRODUCTS:
      return [];
    default:
      return state;
  }
};
